import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { REACT_APP_LD_KEY } from "./variables";

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: REACT_APP_LD_KEY ?? '',
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
    user: {
      key: "paperlessUI",
      name: "paperlessUI",
      email: "",
    },
    options: {},
  });
  
  ReactDOM.render(
    <LDProvider>
      <HashRouter>
        <App url={window.location.href}/>
      </HashRouter>
    </LDProvider>,
    document.getElementById("root"),
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: (console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
